import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Sole purpose is to allow communication between child/parent controllers when one of them has a collapsed state change.
@Injectable()
export class ContainerCollapseService {

  private collapsedStateSource = new Subject<number>();
  public CollapseStateChanged$ = this.collapsedStateSource.asObservable();


  constructor() { }

  public notifyChange(height: number): void {
    this.collapsedStateSource.next(height);
  }

}
